// extracted by mini-css-extract-plugin
export default {"link":"S5mc6U","image":"PHkeYI","root":"DkvjPr","ScotchA":"TtX6xB","scotchA":"TtX6xB","ScotchB":"gk5OnA","scotchB":"gk5OnA"};